import { NavLink, Outlet } from "react-router-dom";

function Admin() {
  return (
    <section className="page">
      <div className="page-title">Admin</div>
      <p className="page-sub">Manage chapters and question frames from dedicated sections.</p>

      <div className="admin-tabs">
        <NavLink to="/admin/chapters" className="auth-link">
          Chapters
        </NavLink>
        <NavLink to="/admin/frames" className="auth-link">
          Frames
        </NavLink>
        <NavLink to="/admin/solution-graphs" className="auth-link">
          Solution Graphs
        </NavLink>
        <NavLink to="/admin/users" className="auth-link">
          Users 
        </NavLink>
      </div>

      <Outlet />
    </section>
  );
}

export default Admin;
